import React from 'react';
import { Box } from '@mui/material';

const ListBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  const {
    items = ['Item 1', 'Item 2', 'Item 3'],
    listType = 'bullet',
    fontSize = 16,
    color = '#333333',
    backgroundColor = 'transparent',
    marginTop = 15,
    marginBottom = 15,
    padding = 10,
    fontWeight = 'normal',
    fontFamily = 'Arial',
    alignment = 'left',
  } = data;

  const getResponsiveFontSize = () => {
    switch (previewMode) {
      case 'mobile':
        return Math.max(fontSize * 0.9, 14);
      case 'tablet':
        return Math.max(fontSize * 0.95, 15);
      default:
        return fontSize;
    }
  };

  return (
    <Box
      sx={{
        fontSize: `${getResponsiveFontSize()}px`,
        color,
        textAlign: alignment,
        marginTop: `${marginTop}px`,
        marginBottom: `${marginBottom}px`,
        padding: `${padding}px`,
        border: isSelected ? '1px dashed #007bff' : 'none',
        borderRadius: isSelected ? '4px' : 0,
        backgroundColor,
        fontFamily,
        fontWeight,
      }}
    >
      {listType === 'bullet' && (
        <ul style={{ margin: 0, paddingLeft: '20px' }}>
          {items.map((item, index) => (
            <li key={index} style={{ marginBottom: '5px' }}>
              {item}
            </li>
          ))}
        </ul>
      )}
      
      {listType === 'numbered' && (
        <ol style={{ margin: 0, paddingLeft: '20px' }}>
          {items.map((item, index) => (
            <li key={index} style={{ marginBottom: '5px' }}>
              {item}
            </li>
          ))}
        </ol>
      )}
      
      {listType === 'none' && (
        <div>
        {items.map((item, index) => (
            <div key={index} style={{ marginBottom: '5px', paddingLeft: '10px' }}>
            {item}
            </div>
        ))}
        </div>
      )}
    </Box>
  );
};

export default ListBlock; 